// extracted by mini-css-extract-plugin
module.exports = {"icomoon-font":"CmsImages_icomoon-font__15i2t","CmsImage":"CmsImages_CmsImage__2icc1","CmsImageHolder":"CmsImages_CmsImageHolder__N_yjI"};